import { render, staticRenderFns } from "./InitialQuizStage.vue?vue&type=template&id=908cb45e&scoped=true&"
import script from "./InitialQuizStage.vue?vue&type=script&lang=ts&"
export * from "./InitialQuizStage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908cb45e",
  null
  
)

export default component.exports